import React, { Fragment, Component } from "react";
import { Col, FormGroup, Row } from "reactstrap";
import {
  getSubcategories,
  removePhraseBetweenCommas,
  uploadPreview,
} from "../../../../../utils/constants";
import findIndex from "lodash/findIndex";
import "./DetailsSection.css";
import * as actionCreators from "../../../../../modules/actions/index";
import { connect } from "react-redux";
import moment from "moment";

class DetailsSection extends Component {
  constructor(props) {
    super(props);
  }

  getDiversityFocusValue = (toolDetails, diversityFocus) => {
    if (toolDetails.diversityFocus && toolDetails.diversityFocus.length > 0) {
      toolDetails.diversityFocus.forEach((selectedFocus) => {
        if (diversityFocus === "" && selectedFocus.focus) {
          diversityFocus =
            selectedFocus.focus !== "Other"
              ? selectedFocus.focus
              : toolDetails.diversityFocusTags.replace(/,/g, ", ");
        } else if (selectedFocus.focus) {
          diversityFocus +=
            ", " +
            (selectedFocus.focus !== "Other"
              ? selectedFocus.focus
              : toolDetails.diversityFocusTags.replace(/,/g, ", "));
        }
      });
    } else if (
      toolDetails.diversityFocusTags &&
      toolDetails.diversityFocusTags !== ""
    ) {
      diversityFocus = toolDetails.diversityFocusTags.replace(/,/g, ", ");
    }
    return diversityFocus;
  };

  getAimedAtFocusValue = (toolDetails, aimedAt) => {
    if (toolDetails.relevantFor && toolDetails.relevantFor.length > 0) {
      toolDetails.relevantFor.forEach((selectedFocus) => {
        if (aimedAt === "" && selectedFocus.focus) {
          aimedAt =
            selectedFocus.focus !== "Other"
              ? selectedFocus.focus
              : toolDetails.relevantForTags.replace(/,/g, ", ");
        } else if (selectedFocus.focus) {
          aimedAt +=
            ", " +
            (selectedFocus.focus !== "Other"
              ? selectedFocus.focus
              : toolDetails.relevantForTags.replace(/,/g, ", "));
        }
      });
    } else if (
      toolDetails.relevantForTags &&
      toolDetails.relevantForTags !== ""
    ) {
      aimedAt = toolDetails.relevantForTags.replace(/,/g, ", ");
    }
    return aimedAt;
  };

  getLocations = (val) => {
    // console.log(val)
    // console.log(val.countries)
    let countries = val.countries;
    let states = val.states;

    let locationString = "";
    if (
      countries &&
      countries.length > 0 &&
      countries !== null &&
      countries !== ""
    ) {
      let usCountryIndex = findIndex(countries, { code: "US" });
      if (usCountryIndex !== -1 && countries.length > 1) {
        let otherCountries = countries.filter(
          (country) => country.code !== "US"
        );
        otherCountries = otherCountries.map(
          (otherCountry) => otherCountry.name
        );
        locationString = otherCountries.toString();
        locationString = `${locationString},${countries[usCountryIndex].name}`;
      } else {
        countries = countries.map((country) => country.name);
        locationString = countries.toString();
      }

      if (states.length > 0) {
        states = states.map((state) => state.name);
        locationString = `${locationString}: ${states.toString()}`;
      }
      locationString = locationString.replace(/,/g, ", ");
    } else locationString = "N/A";
    return locationString;
  };

  createMarkup = (input) => {
    return { __html: `<div> ${input} </div>` };
  };

  check_if_usr_member = (tool, current_user) => {
    console.log("check ---- ", tool);
    console.log("check2 ---- ", current_user);

    // return tool.members && tool.members.filter(e=> e.o_id.toString() == current_user._id.toString()).length>0
    return (
      tool.createdBy._id == current_user._id ||
      this.props.curr_rsvp ||
      (current_user.groups &&
        current_user.groups.length > 0 &&
        current_user.groups.filter(
          (e) => e.o_id.toString() == tool.groupId.toString()
        ).length > 0)
    );
  };

  renderUploadPreview = (source) => {
    return source.map((photo, idx) => {
      let { size, url } = photo;
      console.log("photo ---- ", photo);
      let img = uploadPreview(photo);
      let { preview, isMsIcon } = img;
      let mb = 1024 * 1024;
      let file_size;
      if (size) {
        file_size =
          size >= mb
            ? `${(size / mb).toFixed(2)}mb`
            : `${(size / 1024).toFixed(2)}kb`;
      } else {
        file_size = "";
      }
      if (url == null || url == "") {
        url = photo;
      }
      console.log("url --- ", url);
      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "taskUploadPreviewImg rejectedFilesContainer"
              : "taskUploadPreviewImg"
          }
        >
          <span className="taskUploadPreviewImg_image_wrapper">
          <img src={preview} className="fileUploadSize" />
          </span>

          {/* {this.props.toolDetails.createdBy._id == this.props.user._id?
                <span key={preview+idx} onClick={()=>this.removeImage(photo, )} className="removeTaskUpload">
                <span className='flaticon-trash'/></span>:null} */}
          <div className="previewTaskImageText">
            <span className="previewTaskImageTitle">
              {photo.name ? photo.name : `Attachment ${idx + 1}`}
            </span>
            {/* <span className="previewTaskImageTitle">
                  {file_size}
                </span>  */}
            {(this.props.toolDetails &&
              this.props.toolDetails.privacy != "PRIVATE") ||
            (this.props.toolDetails.privacy == "PRIVATE" &&
              this.check_if_usr_member(
                this.props.toolDetails,
                this.props.user
              )) ||
              this.props.toolDetails.privacy != "PRIVATE" ? (
              <span className="taskAttachmentContent">
                <a href={url} target="_blank">
                  Download
                </a>{" "}
                {file_size ? `(${file_size})` : ""}
              </span>
            ) : null}
          </div>
        </span>
      );
    });
  };

  render() {
    let recommendedDescSection = null;
    let diversityFocus = "";
    let aimedAt = "";
    // let subCategory = '';
    let {
      isRecommendedByAdmin,
      subCategory,
      sponsersName,
      categoryTypes,
      description,
      selectedLocations,
      attachments,
      references,
      relevantFor,
      category,
      name,
      recommendedReason,
      address,
      eventAddress
    } = this.props.toolDetails;
    let subCategories = getSubcategories(category);

    console.log(this.props);

    // console.log(description)
    if (!diversityFocus && !relevantFor && categoryTypes) {
      diversityFocus = categoryTypes["1"];
      relevantFor = categoryTypes["2"];
    }
    diversityFocus = this.getDiversityFocusValue(
      { ...this.props.toolDetails },
      diversityFocus
    );
    aimedAt = this.getAimedAtFocusValue({ ...this.props.toolDetails }, aimedAt);

    let descVal = `${description}`;

    if (isRecommendedByAdmin && recommendedReason) {
      recommendedDescSection = (
        <div>
          <div className="row mt25">
            <div className="recommended-tool-hr-line"></div>
          </div>
          <FormGroup className="description-title mt25" row>
            Why are we recommending this tool?
          </FormGroup>
          <FormGroup
            className="description-content"
            row
            dangerouslySetInnerHTML={this.createMarkup(recommendedReason)}
          ></FormGroup>
        </div>
      );
    }
    if (subCategory) {
      if (typeof subCategory === "string") {
        subCategory = subCategory;
      } else {
        subCategory = subCategory.subCategoryValue;
      }
    }
    // console.log(selectedLocations)

    let attachments_res =
      this.props.toolDetails.attachments &&
      this.props.toolDetails.attachments.length > 0
        ? this.props.toolDetails.attachments
        : [];
    if (
      this.props.toolDetails.attachment &&
      this.props.toolDetails.attachment != ""
    ) {
      attachments_res.push(this.props.toolDetails.attachment);
    }

    return (
      <div className="">
        <FormGroup className="details-title mb25" row>
          Details
        </FormGroup>
        {subCategories.length > 0 && (
          <FormGroup row>
            <Col sm={3} className="details-sub-title text-right pl0">
              Subcategory
            </Col>
            <Col sm={9} className="details-sub-value text-left">
              {subCategory ? subCategory : "N/A"}
            </Col>
          </FormGroup>
        )}
        <FormGroup className="" row>
          <Col sm={3} className="details-sub-title text-right pl0">
            Diversity focus
          </Col>
          <Col sm={9} className="details-sub-value text-left">
            {diversityFocus}
          </Col>
        </FormGroup>
        <FormGroup className="" row>
          <Col sm={3} className="details-sub-title text-right pl0">
            Aimed at
          </Col>
          <Col sm={9} className="details-sub-value text-left">
            {aimedAt}
          </Col>
        </FormGroup>
        {selectedLocations ? (
          <FormGroup className="" row>
            <Col sm={3} className="details-sub-title text-right pl0">
              Locations
            </Col>
            <Col sm={9} className="details-sub-value text-left">
              {this.getLocations(selectedLocations ? selectedLocations : "")}
            </Col>
          </FormGroup>
        ) : null}
        {eventAddress ? (
          <FormGroup className="" row>
            <Col sm={3} className="details-sub-title text-right pl0">
              Address
            </Col>
            <Col sm={9} className="details-sub-value text-left">
              {removePhraseBetweenCommas(eventAddress,"CAL Fire")}
            </Col>
          </FormGroup>
        ) : null}

        <div className="resources_details_page_about_section_containers event_details_about_resources_container">
          <span className="description-title position-relative row form-group">
            Attachments
          </span>
          <div className="taskUploadPreviewContainer mb0">
            {attachments_res && attachments_res.length > 0 ? (
              this.renderUploadPreview(attachments_res)
            ) : (
              <span className="event_details_page_webinar_details_item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                  <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                </svg>
                There are no resources for this event
              </span>
            )}
          </div>
        </div>

        <FormGroup className="description-title" row>
          Description
        </FormGroup>
        <FormGroup
          className="description-content"
          dangerouslySetInnerHTML={this.createMarkup(description)}
        ></FormGroup>
        {references && references !== "" && (
          <div>
            <div className="row mt25">
              <div className="recommended-tool-hr-line"></div>
            </div>
            <FormGroup className="description-title mt25" row>
              References{" "}
            </FormGroup>
            <FormGroup
              className="description-content mt20"
              row
              dangerouslySetInnerHTML={this.createMarkup(references)}
            ></FormGroup>
          </div>
        )}
        {recommendedDescSection}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToolEditLoaded: (data) => dispatch(actionCreators.editToolLoaded(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsSection);
